import { render, staticRenderFns } from "./TestTraining.vue?vue&type=template&id=372ed699&scoped=true&"
import script from "./TestTraining.vue?vue&type=script&lang=ts&"
export * from "./TestTraining.vue?vue&type=script&lang=ts&"
import style0 from "./TestTraining.vue?vue&type=style&index=0&id=372ed699&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372ed699",
  null
  
)

export default component.exports